/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import { GroupProps } from "@/src/components/Wizard/Group";
import CarIcon from "@/src/assets/icons/contract/toggleable/IconCar";
import BuyIcon from "@/src/assets/icons/contract/toggleable/IconGoodsEnforce";
import ServiceIcon from "@/src/assets/icons/contract/toggleable/IconTools";
import MembershipIcon from "@/src/assets/icons/contract/toggleable/IconClub";
import SubscriptionIcon from "@/src/assets/icons/contract/toggleable/IconRepeat";
import ProviderIcon from "@/src/assets/icons/provision/toggleable/IconTransmissionTower";
import TravelIcon from "@/src/assets/icons/contract/toggleable/IconPlane";
import EventIcon from "@/src/assets/icons/contract/toggleable/IconEvent";
import IconQuestionmark from "@/src/assets/icons/common/toggleable/IconQuestionmark";
import React from "react";

export const contractLawDefaultCaseOptions: GroupProps["options"] = [
  {
    labelText: "Fahrzeugkauf",
    labelIcon: <CarIcon />,
    labelIconActive: <CarIcon active />,
    value: "vehicleContract",
    optionHintText:
      "Streitigkeiten rund um den Autokauf. Beispiele: Mängel am Gebrauchtwagen, verschwiegener Unfall oder der Händler verweigert die Reparatur.",
  },
  {
    labelText: "Kaufvertrag",
    labelIcon: <BuyIcon />,
    labelIconActive: <BuyIcon active />,
    value: "purchaseContract",
    optionHintText: "Probleme mit gekauften Waren. Beispiele: Mängel bei Möbeln & Küchen, Streitigkeiten mit Online-Shops oder bei Kleinanzeigen-Betrug.",
  },
  {
    labelText: "Handwerker / Dienstleistung",
    labelIcon: <ServiceIcon />,
    labelIconActive: <ServiceIcon active />,
    value: "serviceContract",
    optionHintText:
      "Streitigkeiten bei Dienstleistungen. Beispiele: Die Werkstatt-Rechnung ist zu hoch, die Reparatur mangelhaft oder Ärger mit einem Coaching-Vertrag.",
  },
  {
    labelText: "Mitgliedschaft",
    labelIcon: <MembershipIcon />,
    labelIconActive: <MembershipIcon active />,
    value: "membershipContract",
    optionHintText:
      "Probleme mit der Mitgliedschaft. Beispiele: Das Fitnessstudio akzeptiert die Kündigung nicht, Beiträge werden weiter abgebucht oder der Vertrag hat sich ungewollt verlängert.",
  },
  {
    labelText: "Abo / Abofalle",
    labelIcon: <SubscriptionIcon />,
    labelIconActive: <SubscriptionIcon active />,
    value: "subscriptionContract",
    optionHintText:
      "Hilfe bei Abofallen und ungewollten Verträgen. Beispiele: Probleme mit Dating-Portalen, Gewinnspielen oder teuren automatischen Verlängerungen.",
  },
  {
    labelText: "Handy / DSL / Strom / Gas -Vertrag",
    labelIcon: <ProviderIcon />,
    labelIconActive: <ProviderIcon active />,
    value: "providerContract",
    optionHintText:
      "Streitigkeiten mit Ihrem Energieversorger oder Netzanbieter. Beispiele: Die Abschlussrechnung ist zu hoch, die Kündigung wird ignoriert oder der Anschluss ist gesperrt.",
  },
  {
    labelText: "Reisevertrag",
    labelIcon: <TravelIcon />,
    labelIconActive: <TravelIcon active />,
    value: "travelContract",
    optionHintText:
      "Probleme rund um Reise & Flug. Beispiele: Flug storniert, das Hotel hatte Mängel oder die Kaution für die Ferienwohnung wird einbehalten.",
  },
  {
    labelText: "Veranstaltung",
    labelIcon: <EventIcon />,
    labelIconActive: <EventIcon active />,
    value: "eventContract",
    optionHintText:
      "Probleme mit Tickets oder Events. Beispiele: Konzert abgesagt, Veranstaltung verschoben oder der Anbieter verweigert die Ticket-Erstattung.",
  },
  {
    labelText: "Keine passende Auswahl?",
    labelIcon: <IconQuestionmark />,
    labelIconActive: <IconQuestionmark active />,
    value: "otherContract",
    optionHintText: "Sie sind sich nicht sicher oder vermuten, dass keine der Vertragsarten genau auf Ihren Fall passt? Wir helfen Ihnen gerne weiter!",
  },
];
